import { BaseAPI } from './BaseAPI.js'
import { CampaignListRecordContactDetails } from '../types/index.js'

export default class CampaignListRecordContactDetailsAPI extends BaseAPI<CampaignListRecordContactDetails> {
  override get resource(): string {
    return '/campaignListRecordContactDetails'
  }
}
